import { z } from "zod";
import { asCategoryId, asItemId, asTemplateId, ok } from "@pack-it-up/shared";
import { AssignmentSchema, CompletionSchema, ProvenanceSchema, assignmentToDomain, assignmentToDto, completionToDomain, completionToDto, parseDto, provenanceToDomain, provenanceToDto, } from "./common.js";
// `listId` (the owning trip/template) is denormalised onto the stored doc for
// per-list queries (Doc 02 §8); it is not a domain field, so it is omitted here and
// added by the repository on write (and ignored on read — zod strips unknown keys).
export const ItemDtoSchema = z.object({
    id: z.string(),
    categoryId: z.string(),
    name: z.string(),
    quantity: z.number().default(1), // Doc 02 §3 — default 1; resilient to a doc missing it
    description: z.string().optional(),
    notes: z.string().optional(),
    tags: z.array(z.string()).optional(), // T29 — user-defined tags; absent, never []
    assignment: AssignmentSchema,
    completions: CompletionSchema,
    staging: CompletionSchema.optional(), // T27 — staged/packed two-step, PackingItem-only
    order: z.string(),
    provenance: ProvenanceSchema.optional(),
    templateIds: z.array(z.string()).optional(),
});
export const toDomainItem = (raw) => {
    const p = parseDto(ItemDtoSchema, raw, "PackingItem");
    if (!p.ok)
        return p;
    const d = p.value;
    const item = {
        id: asItemId(d.id),
        categoryId: asCategoryId(d.categoryId),
        name: d.name,
        quantity: d.quantity,
        ...(d.description !== undefined ? { description: d.description } : {}),
        ...(d.notes !== undefined ? { notes: d.notes } : {}),
        ...(d.tags !== undefined ? { tags: d.tags } : {}),
        assignment: assignmentToDomain(d.assignment),
        completions: completionToDomain(d.completions),
        ...(d.staging !== undefined ? { staging: completionToDomain(d.staging) } : {}),
        order: d.order,
        ...(d.provenance !== undefined ? { provenance: provenanceToDomain(d.provenance) } : {}),
        ...(d.templateIds !== undefined ? { templateIds: d.templateIds.map((t) => asTemplateId(t)) } : {}),
    };
    return ok(item);
};
export const toItemDto = (i) => ({
    id: i.id,
    categoryId: i.categoryId,
    name: i.name,
    quantity: i.quantity,
    ...(i.description !== undefined ? { description: i.description } : {}),
    ...(i.notes !== undefined ? { notes: i.notes } : {}),
    ...(i.tags !== undefined ? { tags: i.tags } : {}),
    assignment: assignmentToDto(i.assignment),
    completions: completionToDto(i.completions),
    ...(i.staging !== undefined ? { staging: completionToDto(i.staging) } : {}),
    order: i.order,
    ...(i.provenance !== undefined ? { provenance: provenanceToDto(i.provenance) } : {}),
    ...(i.templateIds !== undefined ? { templateIds: i.templateIds } : {}),
});
//# sourceMappingURL=item.mapper.js.map